import { lazy, useContext, useEffect, useRef, useState } from "react";

/** Common Components */
import CardSection from "../../components/ui/card/CardSection";
import Documents from "../../common/features/documents/Documents";
import ToolbarButtons from "../../components/toolbarButtons/ToolbarButtons";
import RenderTabs2 from "../../components/ui/tabs/RenderTabs2";

/** Configuration Files */
import { productSaleToolbarConfig } from "./productSale.toolbar.Config";

/** CSS Files */
import "./ProductSale.scss";
import ProductSalesFilter from "./ProductSales.filter";
import FormCreator from "../../components/finalForms/FormCreator";
import { productSalesFormConfig } from "./productSales.formfield.config";
import { useAddProductSalesMutation, useLazyAddProductSalesMutation, useLazyGetAllInventoryPriceQuery, useLazyGetSalesRepQuery } from "../../app/services/productSalesAPI";
import { setDropdownOptions } from "../../components/finalForms/libs/data/mapDropdownOptions";
import ToastService from "../../services/toastService/ToastService";
import { ServiceLocationContext } from "../../utils/context/ServiceLocationContext";
import { getDropdownValue } from "../../utils/formFieldUtils/getDropdownValue";
import CustomCenterModel from "../../components/ui/customCenterModel/CustomCenterModel";
import { AppIcons } from "../../data/appIcons";
import ProductSalesSearch from "./features/productSaleSearch/ProductSalesSearch";
import { useLocation } from "react-router-dom";
import { DocumentCategory, DocumentCategoryType } from "../../utils/ENUMS/documentCategory";

/** Lazy Load Components */
const ProductSalesMain = lazy(() => import("./features/main/ProductSalesMain"));
const ProductSalesAddress = lazy(() => import("./features/address/ProductSalesAddress"));

const ProductSale = (props) => {

  const filterRef = useRef(null);
  const productSalesFormRef = useRef();
  const { selectedLocation } = useContext(ServiceLocationContext);

  const location = useLocation();

  const [productSalesFormData, setProductSalesFormData] = useState(productSalesFormConfig);
  const [selectedClientKey, setSelectedClientKey] = useState(null);
  const [selectedDepartmentKey, setSelectedDepartmentKey] = useState(null);
  const [lProductSaleKey, setLProductSaleKey] = useState(null)
  const [searchModal, setSearchModal] = useState(false)
  const [invoiceNumber, setInvoiceNumber] = useState(null);

  const locationkey = getDropdownValue(selectedLocation);

  const [getSalesRep, {
    isFetching: isGetSalesRepFetching,
    isSuccess: isGetSalesRepFetched,
    data: allGetSalesRepData,
  },] = useLazyGetSalesRepQuery();

  const [getAllInventoryPrice, {
    isFetching: isGetAllInventoryPriceFetching,
    isSuccess: isGetAllInventoryPriceFetched,
    data: allGetAllInventoryPriceData,
  },] = useLazyGetAllInventoryPriceQuery();

  const [addProductSales, {
    isLoading: isAddProductSalesLoading,
    isSuccess: isAddProductSalesSuccess,
    data: addProductSalesData
  }] = useAddProductSalesMutation();

  const handleActionClick = (action) => {
    switch (action) {
      case "SEARCH":
        handleSearchModal();
        break;
      case "NEW":
        handleNewClick();
        break;

      default:
        break;
    }
  };

  const handleInvoiceSelect = (invoiceNo) => {
    setInvoiceNumber(invoiceNo);
    setSearchModal(false);
  };
  console.log("invoiceNumber :", invoiceNumber)
  const tabs = [
    {
      sMenuItemCaption: "Main",
      component: <ProductSalesMain />,
      isDynamic: false,
    },
    {
      sMenuItemCaption: "Address",
      component: <ProductSalesAddress />,
      isDynamic: true,
    },
    {
      sMenuItemCaption: "Documents",
      component: (
        <Documents
          {...props}
          ownerKey={invoiceNumber}
          DocumentCategoryType={DocumentCategoryType.PAPERWORK_PRODUCT_SALE}
          DocumentCategory={DocumentCategory.PRODUCTSALE}
        />
      ),
      isDynamic: true,
    },
  ];


  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    const client = searchParams.get("client");
    const department = searchParams.get("department");
    const sales = searchParams.get("sales");

    if (client && department && sales) {
      setSelectedClientKey(Number(client));
      setSelectedDepartmentKey(Number(department));
      setLProductSaleKey(Number(sales));
    }
  }, [location.search]);


  useEffect(() => {
    let req = {
      plSalesRepKey: 0,
      pbIncludeBlank: false,
      pbIncludeAll: false,
      psActiveFlag: 'Y',
      plCompanyKey: 0,
      plSalesRepKeyToInclude: 0
    }
    getSalesRep(req)
  }, [])

  useEffect(() => {
    let req = {
      plInventoryPricingListKey: 0,
      pbIncludeBlank: false,
      pbIncludeInactive: false,
      plInventoryPricingListKeyToInclude: 0
    }
    getAllInventoryPrice(req)
  }, [])

  useEffect(() => {
    if (!isGetSalesRepFetching && isGetSalesRepFetched && allGetSalesRepData) {
      setDropdownOptions(allGetSalesRepData, 'lSalesRepKey', 'repName', productSalesFormData, 'lSalesRepKey', setProductSalesFormData);
    }
  }, [isGetSalesRepFetching, isGetSalesRepFetched, allGetSalesRepData])

  useEffect(() => {
    if (!isGetAllInventoryPriceFetching && isGetAllInventoryPriceFetched && allGetAllInventoryPriceData) {
      setDropdownOptions(allGetAllInventoryPriceData, 'lInventoryPricingListKey', 'sInventoryPricingList', productSalesFormData, 'lInventoryPricingListKey', setProductSalesFormData);
    }
  }, [isGetAllInventoryPriceFetching, isGetAllInventoryPriceFetched, allGetAllInventoryPriceData])

  useEffect(() => {
    if (isAddProductSalesSuccess && addProductSalesData) {
      ToastService.success("Product Sales Added Successfully");
      setLProductSaleKey(addProductSalesData?.lProductSaleKey)
      if (filterRef.current) {
        filterRef.current.reloadInvoiceDropdown();
      }
    }
  }, [isAddProductSalesSuccess, addProductSalesData]);


  const handleFilterChange = ({ selectedClientKey, selectedDepartmentKey }) => {
    setSelectedClientKey(selectedClientKey);
    setSelectedDepartmentKey(selectedDepartmentKey);
  };

  const handleNewClick = () => {
    let req = {
      plClientKey: selectedClientKey,
      plDepartmentKey: selectedDepartmentKey,
      plServiceLocationKey: locationkey
    }
    addProductSales(req)
  }

  const handleSearchModal = () => {
    setSearchModal(true)
  }

  const handleSearchModalClose = () => {
    setSearchModal(false)
  }

  return (
    <div className="product-sale-section">
      <div className="row justify-content-center">
        <div className="col-12">
          <ToolbarButtons
            toolbarConfiguration={productSaleToolbarConfig}
            onActionClick={handleActionClick}
          />
        </div>
        <div className="col-md-12">
          <div className="top-main-filters form-card px-2">
            <ProductSalesFilter ref={filterRef} onFilterChange={handleFilterChange} lProductSaleKey={lProductSaleKey} onInvoiceChange={setInvoiceNumber} />
          </div>
        </div>

        <div className="col-12">
          <CardSection>
            <FormCreator
              ref={productSalesFormRef}
              config={productSalesFormData}
            />
          </CardSection>
        </div>
        <div className="product-sale-description">
          <RenderTabs2 tabs={tabs} />
        </div>
      </div>
      <CustomCenterModel
        isOpen={searchModal}
        modalTitle={"Product Sales Search"}
        onClose={handleSearchModalClose}
        modalTitleIcon={AppIcons.searchIcon}
        contentClass="content-65"
      >
        <ProductSalesSearch onSelectInvoice={handleInvoiceSelect} setSearchModal={setSearchModal} />
      </CustomCenterModel>
    </div>
  );
};
export default ProductSale;
